// extracted by mini-css-extract-plugin
export var alignCenter = "_7l-d";
export var bannerShown = "_7l-6";
export var buttonContent = "_7l-0";
export var cardList = "_7l-1";
export var centerContent = "_7l-2";
export var chevron = "_7l-3";
export var closePanelButton = "_7l-k";
export var conversationContextContainer = "_7l-l";
export var conversationDetailContainer = "_7l-4";
export var detailWrapper = "_7l-7";
export var dropdownButton = "_7l-e";
export var dropdownTitle = "_7l-9";
export var fullHeight = "_7l-5";
export var hidden = "_7l-a";
export var icon = "_7l-b";
export var mergeSuggestionWrapper = "_7l-m";
export var panel = "_7l-i";
export var portalButtonsWrapper = "_7l-c";
export var right = "_7l-j";
export var tableSummaryContainer = "_7l-8";
export var tableSummaryHeader = "_7l-g";
export var threeDotsButton = "_7l-f";
export var wide = "_7l-h";